import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTsys = (props) => /* @__PURE__ */ _jsx("svg", {
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	viewBox: "0 0 150.99625 51.071201",
	id: "svg4682",
	"inkscape:version": "0.91 r13725",
	"sodipodi:docname": "tsys.svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"inkscape:label": "Layer 1",
		"inkscape:groupmode": "layer",
		id: "layer1",
		transform: "translate(-416.43045,-592.04089)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.25,0,0,-1.25,416.93045,598.56584)",
				id: "g4153",
				children: /* @__PURE__ */ _jsx("path", {
					"inkscape:connector-curvature": 0,
					id: "path4155",
					style: {
						fill: "currentColor",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					d: "m 0,0 0,-7.603 7.848,0 0,-23.11 9.777,0 0,23.11 7.847,0 0,7.603"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.25,0,0,-1.25,499.56295,599.52214)",
				id: "g4157",
				children: /* @__PURE__ */ _jsx("path", {
					"inkscape:connector-curvature": 0,
					id: "path4159",
					style: {
						fill: "currentColor",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					d: "M 0,0 5.777,-9.748 11.472,0 22.316,0 10.384,-16.969 l 0,-12.319 -9.338,0 0,12.319 L -10.799,0"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.25,0,0,-1.25,542.41045,612.32834)",
				id: "g4161",
				children: /* @__PURE__ */ _jsx("path", {
					"inkscape:connector-curvature": 0,
					id: "path4163",
					style: {
						fill: "currentColor",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					d: "m 0,0 c -2.553,0.454 -4.062,0.827 -4.062,2.241 0,1.491 1.759,1.905 3.351,1.905 1.506,0 3.765,-0.25 5.485,-1.077 C 6.07,2.405 6.575,1.741 7.034,1.16 l 2.434,2.015 0,-5.908 C 6.969,-1.207 3.491,-0.596 0,0 m 10.148,15.829 c -0.379,0 -0.68,-0.304 -0.68,-0.678 l 0,-6.309 c -0.289,0.164 -0.593,0.329 -0.927,0.49 -2.429,1.203 -5.524,1.867 -8.918,1.867 -5.316,0 -10.298,-1.7 -12.224,-6.015 -0.543,-1.16 -0.838,-2.491 -0.838,-3.776 0,-6.182 5.318,-7.842 8.037,-8.547 1.217,-0.29 6.658,-1.242 7.705,-1.616 1.632,-0.541 1.632,-1.62 1.632,-1.825 0,-2.118 -3.682,-2.198 -4.437,-2.198 -1.423,0 -2.932,0.248 -4.145,0.662 -2.554,0.83 -3.265,1.909 -4.102,3.193 l -7.16,-4.563 c 1.34,-1.618 3.516,-4.229 8.208,-5.557 2.299,-0.662 4.645,-0.871 6.864,-0.871 1.491,0 6.589,0.003 10.305,2.894 l 0,-6.533 c 0,-0.37 0.301,-0.674 0.68,-0.674 0.377,0 0.68,0.304 0.68,0.674 l 0,38.704 c 0,0.374 -0.303,0.678 -0.68,0.678"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.25,0,0,-1.25,470.44045,628.29964)",
				id: "g4165",
				children: /* @__PURE__ */ _jsx("path", {
					"inkscape:connector-curvature": 0,
					id: "path4167",
					style: {
						fill: "currentColor",
						fillOpacity: 1,
						fillRule: "nonzero",
						stroke: "none"
					},
					d: "m 0,0 c -1.422,0 -2.93,0.247 -4.146,0.662 -2.554,0.83 -3.266,1.908 -4.1,3.193 l -2.518,-1.6 0,6.327 C -8.977,6.798 -6.493,6.054 -4.898,5.639 -3.685,5.349 1.757,4.397 2.804,4.023 4.438,3.482 4.438,2.402 4.438,2.198 4.438,0.08 0.753,0 0,0 m 0.503,12.778 c -2.554,0.453 -4.063,0.827 -4.063,2.241 0,1.491 1.76,1.904 3.349,1.904 1.507,0 3.77,-0.25 5.487,-1.076 1.297,-0.664 1.8,-1.328 2.26,-1.909 l 5.863,4.854 c -1.048,1.077 -2.139,2.239 -4.355,3.317 -2.429,1.204 -5.526,1.867 -8.919,1.867 -4.353,0 -8.477,-1.139 -10.889,-3.915 l 0,7.868 c 0,0.374 -0.301,0.678 -0.678,0.678 -0.378,0 -0.685,-0.304 -0.685,-0.678 l 0,-38.704 c 0,-0.37 0.307,-0.674 0.685,-0.674 0.377,0 0.678,0.304 0.678,0.674 l 0,5.974 c 0.994,-0.56 2.168,-1.069 3.563,-1.464 2.303,-0.662 4.646,-0.871 6.864,-0.871 1.633,0 7.58,0 11.306,3.775 1.34,1.367 2.641,3.526 2.641,6.595 0,7.261 -6.534,8.422 -13.107,9.544"
				})
			})
		]
	})
});
export default SvgTsys;
